import type { Action } from 'state/actions';
import type { OrderActionType } from 'state/secondaryMarket/shared/actions';
import type { AmendErrorType, AmendedTradeMap } from 'state/secondaryMarket/shared/amend/amend.model';
import { initialAmendedTradeMap, intialAmendedTrade } from 'state/secondaryMarket/shared/amend/amend.model';
import { addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';
import type { LoadingStatus } from 'utils/status';

export function amendTradeReducerFactory(actionType: OrderActionType) {
  return (state: AmendedTradeMap = initialAmendedTradeMap(), action: Action): AmendedTradeMap => {
    switch (action.type) {
      case 'SECONDARY_MARKET_POSTEVENT_WORKSPACE_ADD_TAB':
      case `SECONDARY_MARKET_${actionType}_FORM_RESET` as const:
        return addOrReplaceKey(state, action.tabId, intialAmendedTrade());
      case `SECONDARY_MARKET_${actionType}_AMEND_REQUESTED` as const:
        return patchKey(state, action.tabId, () => ({ status: 'pending' as LoadingStatus }));
      case `SECONDARY_MARKET_${actionType}_AMEND_RECEIVED` as const:
        return patchKey(state, action.tabId, () => ({
          status: 'success' as LoadingStatus,
          validations: action.validations,
        }));
      case `SECONDARY_MARKET_${actionType}_AMEND_FAILED` as const:
        return patchKey(state, action.tabId, () => ({
          status: 'error' as LoadingStatus,
          errorMessage: action.errorMessage,
          errorType: 'failed' as AmendErrorType,
        }));
      case `SECONDARY_MARKET_${actionType}_AMEND_REJECTED` as const:
        return patchKey(state, action.tabId, () => ({
          status: 'error' as LoadingStatus,
          errorMessage: action.errorMessage,
          errorType: 'rejected' as AmendErrorType,
        }));
      case `SECONDARY_MARKET_${actionType}_AMEND_COLLIDED` as const:
        return patchKey(state, action.tabId, () => ({
          status: 'error' as LoadingStatus,
          errorMessage: action.errorMessage,
          errorType: 'collided' as AmendErrorType,
        }));
      case 'SECONDARY_MARKET_POSTEVENT_WORKSPACE_REMOVE_TAB':
        return removeKey(state, action.tabId);
      default:
        return state;
    }
  };
}
